
            
            <ng-container *ngIf="trialUser == 0" >

        <p><strong>Hi {{ username }} ,</strong></p>
       
            <p>Awesome to see you signed up — welcome aboard!</p>
       
            <p>You can now place your first order, track progress, and message support anytime.<br/> If you’d like help getting started or choosing the right service, just reply. I’m happy to guide you through it.</p>
       
            <p>Talk soon,<br>
            Sarah</p>
       
         <br>
            <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
 
            <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                <tr>
                    <td width="100" align="left" valign="top" style="padding-right: 10px;">
                        <img src="https://backend.skyscrapersnow.com/images/sarah.png" alt="Sarah A." width="97" height="124" style="border-radius: 8px; display: block;">
                    </td>
                    <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                         <img src="https://backend.skyscrapersnow.com/images/sarah_sign.png" alt="Sarah A Signature" style="max-width: 82px;
    max-height: 34px;
    display: block;
    margin-bottom: 5px;">
                        <p style="font-weight: 500;
    font-size: 18px;
    color: #000000;

    text-align: left;
    margin: 0;">Sarah A.</p>
                        <p style="margin: 7px 0;
    color: #767E8C;
    font-size: 13px;
    text-align: left;">Student Support Specialist</p>
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" style="padding: 0px;">
                                    <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                </td>
                                <td valign="middle" style="font-size: 13px;color: #767E8C; padding: 0px 0px 0px 5px;">
                                    <a href="https://' . $site_link_clean . '" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
         
            </ng-container>
            <ng-container *ngIf="trialUser == 1" >
                <table width:100%;>
                        <tr>
                            <td>
                                <table width="100%" class="main"
                                    style="width: 100%;max-width: 600px;margin: 0 auto; padding:30px 49px 35px; border-spacing: 0;">
                                    <tr>
                                        <td>
                                            <a href="https://' . $SETTING['site_link'] . '">
                                                <img class="psh-email-logo"
                                                    style="max-width:227px;width:100%; border-radius: 0px; display:block;margin:0 auto 36px;object-fit:cover;background-color:none;"
                                                    src="'.$logo_path.'"
                                                    alt="'. $SETTING['sitename'].'" title="'. $SETTING['sitename'].'">
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p class="content"
                                            style="font-family:\'Helvetica\'; margin:0; font-size:14px; line-height:24px; color: #000000;font-weight: 400;padding-bottom: 18px;">
                                                Hi {{ username }},
                                            </p>
                                            <p class="content"
                                            style="font-family:\'Helvetica\'; margin:0; font-size:14px; line-height:24px; color: #000000;font-weight: 400;padding-bottom: 18px;">
                                                Your trial isn’t over — you still have free words to use.
                                            </p>
                                            <p class="content"
                                            style="font-family:\'Helvetica\'; margin:0; font-size:14px; line-height:24px; color: #000000;font-weight: 400;padding-bottom: 18px;">
                                                You can use those to:
                                                Draft a full essay
                                                Rewrite your last one
                                                Check for plagiarism or fix grammar
                                            </p>
                                            <p class="content"
                                            style="font-family:\'Helvetica\'; margin:0; font-size:14px; line-height:24px; color: #000000;font-weight: 400;padding-bottom: 18px;">
                                                And if you're ever stuck or overwhelmed, we also offer a custom writing service — handled by real academic writers. Totally confidential. Delivered fast.
                                            </p>
                                            <p class="content"
                                            style="font-family:\'Helvetica\'; margin:0; font-size:14px; line-height:24px; color: #000000;font-weight: 400;padding-bottom: 18px;">
                                                See you inside,
                                            </p>
                                            <p style="font-family:\'Helvetica\'; margin:0 0 20px; font-size:14px; line-height:24px; color: #000000; padding-bottom:5px; margin-bottom: 149px;">
                                                — Team {{ sitename | formatSitename }}<br>
                                            </p>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
            </ng-container>